import styled from 'styled-components';
import { Flex } from 'rebass';

export default styled(Flex)`
    padding: 16px;
    border-bottom: 1px solid #eee;
    flex-wrap: wrap;
`;
